import React, { Fragment } from "react";
import { Typography, Stack } from "@mui/material";
import { TextAreaField } from "./textArea";
import { CustomSelectField } from "./customSelect";
import { CustomTextArea } from "../../../components/fields/CustomTextArea/CustomTextArea";

export default function Qualifications() {
  return (
    <Fragment key="qualifications">
      <Typography
        variant="h4"
        sx={{
          color: "var(--Base-1000, #000)",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          lineHeight: "132%",
        }}
      >
        Qualifications
      </Typography>
      <hr style={{ color: "var(--border)", marginTop: "16px" }} />

      <Stack direction="row"  spacing={3} mb={3} mt={2}>
        <CustomSelectField
          name="levelOfEducation"
          label="Level of Education"
          options={[
            "High School",
            "Bachelor's degree",
            "Master's degree",
            "Doctorate or higher",
            "Other",
          ]}
        />
      </Stack>
      <CustomTextArea
        name="fieldOfStudy"
        label="Field of Study (If applicable)"
        placeholder="Software Engineering"
        rows={3}
      />
    </Fragment>
  );
}
